import { render, staticRenderFns } from "./AccountingDocumentsList.vue?vue&type=template&id=52de7e43&"
import script from "./AccountingDocumentsList.vue?vue&type=script&lang=js&"
export * from "./AccountingDocumentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports